import { ProductVariant } from "@medusajs/medusa"
import { PricedVariant } from "@medusajs/medusa/dist/types/pricing"
import { EnrichedMedusaVariant } from "gatsby-node"

export const getMinimumPrice = (
  variants: ProductVariant[] | PricedVariant[] | EnrichedMedusaVariant[]
) => {
  if (!variants?.length) {
    return
  }

  return Math.min(
    // @ts-ignore
    ...variants?.map((i) => i && i.calculated_price_incl_tax)
  )
}
